import React from 'react'
import { connect } from 'react-redux'

import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import { getDefaultAirportCode } from 'selectors/flightsSelectors'
import Caption from 'components/Luxkit/Typography/Caption'
import {
  OFFER_TYPE_TOUR,
} from 'constants/offer'
import { useTranslation } from 'react-i18next'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import HotelPlusFlightsFrom from 'components/Common/HotelPlusFlightsFrom'

interface Props {
  offer: App.Offer | App.OfferSummary;
  flightOrigin?: string;
  className?: string;
}

function FrontPageTileFlightPricing(props: Props) {
  const {
    offer,
    flightOrigin,
    className,
  } = props

  const {
    flightCacheDisabled,
    lowestPricePackage,
    type,
    flightsEnabled,
  } = offer

  const { t } = useTranslation(['hotelOfferList', 'tourOfferList'])

  const flightCacheOn = !flightCacheDisabled && offer.flightPrices[flightOrigin || '']

  if (flightCacheOn && type !== OFFER_TYPE_TOUR) {
    const price = (lowestPricePackage?.price ?? 0) + offer.flightPrices[flightOrigin || '']
    return <HotelPlusFlightsFrom price={price} forTwoAdults />
  }

  let message = <Caption as="span" variant="large" colour="neutral-one">{t('hotelPlusFlightPackageAvailable', { ns: 'hotelOfferList' })}</Caption>
  const isFlightsEnabledWithTours = type === OFFER_TYPE_TOUR && flightsEnabled
  if (isFlightsEnabledWithTours) {
    message = <Caption as="span" variant="large" colour="neutral-one">{t('tourPlusFlightsPackageAvailable', { ns: 'tourOfferList' })}</Caption>
  }

  return <CaptionTextBlock className={className} variant="large" wrap="pre-wrap" startIcon={<LinePlaneFlyIcon colour="neutral-one" />}>
    {message}
  </CaptionTextBlock>
}

function mapStateToProps(state: App.State) {
  return {
    flightOrigin: getDefaultAirportCode(state),
  }
}

export default connect(mapStateToProps)(FrontPageTileFlightPricing)
